import { render } from "./HButton.vue?vue&type=template&id=1b31aa2a&scoped=true"
import script from "./HButton.vue?vue&type=script&lang=js"
export * from "./HButton.vue?vue&type=script&lang=js"

import "./HButton.vue?vue&type=style&index=0&id=1b31aa2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b31aa2a"]])

export default __exports__